export default {
  'teamsMessageTrace.title': 'Trazas Mensajes Teams',
};
